import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      OPEN: "Åpne",
      CLOSE: "Lukk",
      THANK_YOU_FOR_RATING: "Takk for vurderingen!",
      GIVE_US_YOUR_RATING: "Vurder middagen",
      SAVE: "Lagre",
      HAVE_NOT_MADE_THE_DISH: "Har ikke laget",
    },
    se: {
      OPEN: "Öppna",
      CLOSE: "Stäng",
      THANK_YOU_FOR_RATING: "Tack för ditt betyg!",
      GIVE_US_YOUR_RATING: "Betygsätt middagen",
      SAVE: "Spara",
      HAVE_NOT_MADE_THE_DISH: "Har inte lagat rätten",
    },
    dk: {
      OPEN: "Åbne",
      CLOSE: "Luk",
      THANK_YOU_FOR_RATING: "Tak for din vurdering!",
      GIVE_US_YOUR_RATING: "Giv os din vurdering!",
      SAVE: "Gem",
      HAVE_NOT_MADE_THE_DISH: "Har ikke lavet retten",
    },
  } as const
)[language];
